/**
 * @voltxampere/ui — Potentiometer (Pot) · v1.0.1 IEC zigzag + 45° brass wiper
 *
 * Brand-bible v1.0.1 addendum (2026-04-25): the canonical "double-
 * triangle" pot is replaced with the *resistor IEC zigzag* plus a
 * brass wiper terminal entering from below at 45°. The wiper sits
 * outside the resistor body; the canvas connects external wiring at
 * `(24, 25)` near the bottom edge of the viewBox.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_BRASS, STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const potentiometer = {
    id: "potentiometer",
    nameTr: "Pot",
    nameEn: "Potentiometer",
    shortcut: "P",
    category: "passive",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, label: "1", polarity: "bi" },
        { x: 40, y: 13, label: "2", polarity: "bi" },
        { x: 24, y: 25, label: "W", polarity: "bi" },
    ],
    defaultLabel: "RV",
    defaultValue: "10kΩ",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="6" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<path d="M 6 13 L 10 6 L 14 20 L 18 6 L 22 20 L 26 6 L 30 20 L 34 13 L 40 13" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}" stroke-linejoin="round"/>`,
        `<line x1="24" y1="25" x2="18" y2="19" stroke="${STROKE_BRASS}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<polygon points="16,17 21,18 18,21" fill="${STROKE_BRASS}"/>`,
    ].join(""),
};
//# sourceMappingURL=potentiometer.js.map